/* Trend Tonic landing sections — shared behaviour
   Loaded with `defer` by every tt-* section. Safe to load more than once. */
(function () {
  if (window.TTLanding) return; // already loaded by another section
  document.documentElement.classList.add('tt-js');

  var cfg = window.ttSettings || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && Shopify.designMode);

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || cfg.moneyFormat || '£{{amount}}';
    function fmt(n, dec, th, dc) {
      dec = dec == null ? 2 : dec; th = th || ','; dc = dc || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(dec);
      var p = n.split('.');
      return p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th) + (p[1] ? dc + p[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/), v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ---------- toast ---------- */
  var toast, toastT;
  function showToast(title, sub, isError) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'tt-toast'; toast.setAttribute('role', 'status');
      toast.innerHTML = '<span class="tt-toast__ck">✓</span><span><b></b><small></small></span>';
      document.body.appendChild(toast);
    }
    toast.classList.toggle('is-error', !!isError);
    toast.querySelector('.tt-toast__ck').textContent = isError ? '!' : '✓';
    toast.querySelector('b').textContent = title;
    var s = toast.querySelector('small');
    s.innerHTML = '';
    s.appendChild(document.createTextNode(sub || ''));
    if (!isError && cfg.cartUrl) {
      var a = document.createElement('a'); a.href = cfg.cartUrl; a.textContent = cfg.viewCartText || 'View bag';
      s.appendChild(a);
    }
    toast.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toast.classList.remove('is-on'); }, 3200);
  }

  /* ---------- cart ---------- */
  function refreshCartUI(cart) {
    // generic counters
    document.querySelectorAll('[data-cart-count],.cart-count-bubble span[aria-hidden="true"],.cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    // Dawn / Dawn-based themes: re-render header bubble
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      fetch(root + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
        if (!s['cart-icon-bubble']) return;
        var tmp = document.createElement('div'); tmp.innerHTML = s['cart-icon-bubble'];
        var inner = tmp.querySelector('.shopify-section') || tmp;
        bubble.innerHTML = inner.innerHTML;
      }).catch(function () {});
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('tt:cart:updated', { detail: cart }));
  }

  function addToCart(variantId, qty, btn, name) {
    if (!variantId) return;
    return addItems([{ id: Number(variantId), quantity: qty || 1 }], btn, name);
  }
  function addItems(items, btn, name) {
    if (!items || !items.length) return;
    if (btn) btn.classList.add('is-loading');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('is-loading');
        if (!res.ok) { showToast(cfg.errorText || 'Could not add to bag', res.j.description || res.j.message || '', true); return false; }
        if (cfg.afterAdd === 'cart') { window.location.href = cfg.cartUrl || root + 'cart'; return true; }
        if (cfg.afterAdd === 'checkout') { window.location.href = root + 'checkout'; return true; }
        var drawer = document.querySelector('cart-drawer');
        if (cfg.afterAdd === 'drawer' && drawer && typeof drawer.renderContents === 'function' && res.j.sections) {
          drawer.classList.remove('is-empty');
          try { drawer.renderContents(res.j); } catch (e) {}
          if (btn) btn.classList.remove('is-loading');
          return true;
        }
        if (drawer && res.j.sections && res.j.sections['cart-drawer']) {
          // keep Dawn's drawer in sync without opening it
          var tmp = document.createElement('div'); tmp.innerHTML = res.j.sections['cart-drawer'];
          var fresh = tmp.querySelector('#CartDrawer'), old = document.getElementById('CartDrawer');
          if (fresh && old) { old.innerHTML = fresh.innerHTML; drawer.classList.remove('is-empty'); }
        }
        var item = res.j.items ? res.j.items[0] : res.j;
        showToast((name || (item && item.product_title) || 'Item') + ' ' + (cfg.addedText || 'added'), cfg.toastSub || '');
        if (btn && btn.classList.contains('tt-add')) {
          var old = btn.innerHTML; btn.classList.add('is-done'); btn.textContent = cfg.addedBtnText || 'Added ✓';
          setTimeout(function () { btn.innerHTML = old; btn.classList.remove('is-done'); }, 1600);
        }
        fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(refreshCartUI).catch(function () {});
        return true;
      })
      .catch(function () { if (btn) btn.classList.remove('is-loading'); showToast(cfg.errorText || 'Could not add to bag', '', true); return false; });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-tt-add]');
    if (!f) return;
    if (cfg.afterAdd === 'native') return; // let theme handle it
    e.preventDefault();
    var id = f.querySelector('[name="id"]');
    var q = f.querySelector('[name="quantity"]');
    addToCart(id && id.value, q ? parseInt(q.value, 10) || 1 : 1, f.querySelector('[type="submit"]'), f.getAttribute('data-tt-name'));
  });

  /* ---------- reveal + count up ---------- */
  var io = null;
  if ('IntersectionObserver' in window && !reduce && !designMode) {
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.remove('tt-pre');
        io.unobserve(e.target);
        e.target.querySelectorAll('[data-tt-count]').forEach(countUp);
        if (e.target.hasAttribute('data-tt-count')) countUp(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
  }
  function countUp(n) {
    if (reduce || n._ttCounted) return; n._ttCounted = true;
    var to = parseFloat(n.getAttribute('data-tt-count')); if (isNaN(to)) return;
    var dec = +(n.getAttribute('data-tt-dec') || 0), pre = n.getAttribute('data-tt-prefix') || '', suf = n.getAttribute('data-tt-suffix') || '', t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min((t - t0) / 1400, 1), v = to * (1 - Math.pow(1 - k, 3));
      n.textContent = pre + (dec ? v.toFixed(dec) : Math.round(v).toLocaleString()) + suf;
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initReveal(scope) {
    var els = scope.querySelectorAll('.tt-rv, .tt-scale');
    if (!io) { els.forEach(function (el) { el.classList.remove('tt-pre'); }); return; }
    var vh = window.innerHeight;
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top > vh * 0.92) { el.classList.add('tt-pre'); io.observe(el); }
    });
    // safety: never leave content hidden
    setTimeout(function () { els.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.remove('tt-pre'); }); }, 2500);
  }

  /* ---------- featured product ---------- */
  function initFeatured(sec) {
    var dataEl = sec.querySelector('[data-tt-product-json]');
    if (!dataEl) return;
    var product; try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = sec.querySelector('form[data-tt-add]');
    var idInput = form && form.querySelector('[name="id"]');
    var btn = form && form.querySelector('[type="submit"]');
    var nowEl = sec.querySelector('[data-tt-price]'), wasEl = sec.querySelector('[data-tt-compare]'), saveEl = sec.querySelector('[data-tt-save]');
    var customSave = saveEl && saveEl.getAttribute('data-tt-custom');
    var btnTpl = btn && btn.getAttribute('data-tt-label') || 'Add to bag · [price]';
    var soldTxt = btn && btn.getAttribute('data-tt-sold') || 'Sold out';
    var groups = sec.querySelectorAll('[data-tt-option-index]');
    var slides = sec.querySelectorAll('.tt-spot__slide');
    var switches = sec.querySelectorAll('[data-tt-slide]');

    // images: a swipe track (finger swipe on phones, drag with a mouse), thumbnails/dots follow it
    var slidesBox = sec.querySelector('[data-tt-spot-track]');
    function mark(mediaId) {
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(mediaId)); });
      switches.forEach(function (b) {
        var on = b.getAttribute('data-tt-slide') === String(mediaId);
        b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.classList.toggle('is-active', on);
        if (on && b.parentElement && b.parentElement.scrollWidth > b.parentElement.clientWidth) {
          var p = b.parentElement; p.scrollTo({ left: b.offsetLeft - p.clientWidth / 2 + b.clientWidth / 2, behavior: 'smooth' });
        }
      });
    }
    var spotSlider = null;
    if (slidesBox && slides.length > 1) {
      spotSlider = TTSlider(slidesBox, { mouse: true, autoHeight: function () { return window.matchMedia('(max-width: 749px)').matches; }, onChange: function (i, el) { if (el) mark(el.getAttribute('data-media-id')); } });
    }
    function showSlide(mediaId, smooth) {
      var el = null;
      slides.forEach(function (s) { if (s.getAttribute('data-media-id') === String(mediaId)) el = s; });
      if (!el) return;
      mark(mediaId);
      if (spotSlider) spotSlider.goToEl(el, smooth);
    }
    switches.forEach(function (b) { b.addEventListener('click', function () { showSlide(b.getAttribute('data-tt-slide')); }); });
    var startSlide = sec.querySelector('.tt-spot__slide.is-active');
    if (startSlide && spotSlider) requestAnimationFrame(function () { showSlide(startSlide.getAttribute('data-media-id'), false); });

    function selected() {
      var opts = [];
      groups.forEach(function (g) { var p = g.querySelector('[aria-pressed="true"]'); opts[+g.getAttribute('data-tt-option-index')] = p ? p.getAttribute('data-value') : null; });
      return opts;
    }
    function update() {
      var opts = selected();
      var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); });
      // availability styling
      groups.forEach(function (g) {
        var idx = +g.getAttribute('data-tt-option-index');
        g.querySelectorAll('[data-value]').forEach(function (b) {
          var test = opts.slice(); test[idx] = b.getAttribute('data-value');
          var ok = product.variants.some(function (x) { return x.available && x.options.every(function (o, i) { return test[i] == null || o === test[i]; }); });
          b.classList.toggle('is-unavailable', !ok);
        });
      });
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-tt-unavail') || 'Unavailable'; } return; }
      if (idInput) idInput.value = v.id;
      var price = formatMoney(v.price);
      if (nowEl) nowEl.textContent = price;
      if (wasEl) { wasEl.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : ''; wasEl.hidden = !(v.compare_at_price > v.price); }
      if (saveEl && !customSave) {
        var pct = v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
        saveEl.hidden = !pct; saveEl.textContent = (saveEl.getAttribute('data-tt-tpl') || 'Save [percent]%').replace('[percent]', pct);
      }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btnTpl.replace('[price]', price) : soldTxt; }
      if (v.featured_media && v.featured_media.id) showSlide(v.featured_media.id);
      if (form) form.setAttribute('data-tt-name', product.title);
    }
    groups.forEach(function (g) {
      g.querySelectorAll('[data-value]').forEach(function (b) {
        b.addEventListener('click', function () {
          g.querySelectorAll('[data-value]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true'); update();
        });
      });
    });
    update();
  }

  /* ---------- product grid tabs: own collection/products per tab, or tag filter on 'All' ---------- */
  function initGrid(sec) {
    var chips = sec.querySelectorAll('[data-tt-filter], [data-tt-tab]');
    var panels = sec.querySelectorAll('[data-tt-panel]');
    var allPanel = sec.querySelector('[data-tt-panel="all"]') || sec;
    var cards = allPanel.querySelectorAll('.tt-pcard');
    var viewAll = sec.querySelector('[data-tt-viewall]');
    function refresh(panel) {
      var g = panel && panel.querySelector('.tt-mslider');
      if (g) g.dispatchEvent(new CustomEvent('tt:filtered'));
      if (panel) panel.querySelectorAll('.tt-pre').forEach(function (r) { r.classList.remove('tt-pre'); });
    }
    function show(panelId) {
      var shown = null;
      panels.forEach(function (p) { var on = p.getAttribute('data-tt-panel') === panelId; p.hidden = !on; if (on) shown = p; });
      return shown;
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        c.setAttribute('aria-pressed', 'true');
        var panel;
        if (c.hasAttribute('data-tt-tab')) {
          panel = show(c.getAttribute('data-tt-tab'));
        } else {
          panel = show('all') || allPanel;
          var f = (c.getAttribute('data-tt-filter') || '').toLowerCase().trim();
          cards.forEach(function (card) {
            var tags = ('|' + (card.getAttribute('data-tags') || '').toLowerCase() + '|');
            card.hidden = !(f === '' || f === 'all' || tags.indexOf('|' + f + '|') > -1);
          });
        }
        refresh(panel);
        if (viewAll && viewAll.getAttribute('data-follow') === '1') {
          var a = viewAll.querySelector('a'), u = c.getAttribute('data-tt-url');
          if (a) a.setAttribute('href', u || viewAll.getAttribute('data-default') || a.getAttribute('href'));
        }
      });
    });
    var pressed = sec.querySelector('[data-tt-filter][aria-pressed="true"], [data-tt-tab][aria-pressed="true"]');
    if (pressed && pressed.getAttribute('data-tt-filter') !== 'all') pressed.click();
  }

  /* ---------- quiz ---------- */
  function initQuiz(sec) {
    var res = sec.querySelector('.tt-result'); if (!res) return;
    var state = {};
    var groups = sec.querySelectorAll('[data-tt-q]');
    function render() {
      var vibe = state.vibe;
      res.querySelectorAll('.tt-result__p').forEach(function (p) { p.hidden = p.getAttribute('data-tt-vibe') !== vibe; });
      var tip = state.earsTip || '';
      res.querySelectorAll('[data-tt-tip]').forEach(function (t) { t.textContent = tip; t.parentElement.hidden = !tip; });
      res.classList.remove('tt-swap'); void res.offsetWidth; res.classList.add('tt-swap');
    }
    groups.forEach(function (g) {
      var key = g.getAttribute('data-tt-q');
      var opts = g.querySelectorAll('.tt-q__opt');
      opts.forEach(function (o) {
        if (o.getAttribute('aria-pressed') === 'true') { state[key] = o.getAttribute('data-v'); if (key === 'ears') state.earsTip = o.getAttribute('data-tip'); }
        o.addEventListener('click', function () {
          opts.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          o.setAttribute('aria-pressed', 'true');
          state[key] = o.getAttribute('data-v');
          if (key === 'ears') state.earsTip = o.getAttribute('data-tip');
          render();
        });
      });
    });
    render();
  }

  /* ---------- ugc video ---------- */
  function initVideos(sec) {
    sec.querySelectorAll('.tt-ugc__play').forEach(function (b) {
      b.addEventListener('click', function () {
        var wrap = b.closest('.tt-ugc__it'); var v = wrap.querySelector('video');
        if (!v) return; wrap.classList.add('is-playing'); v.controls = true; v.muted = false; v.play();
      });
    });
  }

  /* ---------- sticky bar ---------- */
  function initSticky(bar) {
    if (bar._tt) return; bar._tt = true;
    var after = parseFloat(bar.getAttribute('data-tt-after') || '90') / 100;
    var btn = bar.querySelector('a,button');
    function onScroll() {
      var hide = false;
      document.querySelectorAll('[data-tt-hide-sticky]').forEach(function (s) {
        var r = s.getBoundingClientRect();
        if (r.top < innerHeight * 0.6 && r.bottom > innerHeight * 0.4) hide = true;
      });
      var on = scrollY > innerHeight * after && !hide;
      if (designMode) on = true;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
    }
    addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }


  /* ---------- touch slider (mobile sliders + product gallery) ----------
     Horizontal swiping is handled in JS (touch-action: pan-y), so it works the same
     in every browser and inside app webviews / the Shopify mobile preview, where
     native horizontal scrolling can be swallowed. Dots show position and are tappable. */
  function TTSlider(el, opts) {
    if (el._ttSlider) return el._ttSlider;
    opts = opts || {};
    var self = { el: el, index: 0 };
    el._ttSlider = self;
    var mq = opts.media ? window.matchMedia(opts.media) : null;
    var dotsWrap = opts.dots || null, dots = [];
    function slides() { return [].slice.call(el.children).filter(function (c) { return !c.hidden && c.offsetParent !== null && !c.hasAttribute('data-tt-ignore'); }); }
    function active() { return !mq || mq.matches; }
    function posOf(i) { var sl = slides(); if (!sl.length) return 0; var t = sl[Math.max(0, Math.min(i, sl.length - 1))]; return t.offsetLeft - sl[0].offsetLeft; }
    function nearest() {
      var sl = slides(), x = el.scrollLeft, best = 0, bd = Infinity;
      sl.forEach(function (c, i) { var d = Math.abs(posOf(i) - x); if (d < bd) { bd = d; best = i; } });
      // at the far end, treat as last slide
      if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 4) best = sl.length - 1;
      return best;
    }
    // autoHeight: the slider takes the height of the slide on show (photos of different shapes)
    function autoOn() { return typeof opts.autoHeight === 'function' ? opts.autoHeight() : !!opts.autoHeight; }
    function fit(i) {
      if (!autoOn()) { if (el.classList.contains('tt-autoh')) { el.classList.remove('tt-autoh'); el.style.height = ''; } return; }
      var sl = slides()[i]; if (!sl) return;
      el.classList.add('tt-autoh');
      var h = sl.offsetHeight; if (h > 0) el.style.height = h + 'px';
    }
    self.fit = function () { fit(self.index); };
    function go(i, smooth) {
      var sl = slides(); if (!sl.length) return;
      i = Math.max(0, Math.min(i, sl.length - 1));
      self.index = i; fit(i);
      var left = Math.min(posOf(i), el.scrollWidth - el.clientWidth);
      try { el.scrollTo({ left: left, behavior: smooth === false ? 'auto' : 'smooth' }); } catch (e) { el.scrollLeft = left; }
      paint(i);
      if (opts.onChange) opts.onChange(i, sl[i]);
    }
    self.go = go;
    self.next = function () { go(nearest() + 1); };
    self.prev = function () { go(nearest() - 1); };
    self.goToEl = function (child, smooth) { var i = slides().indexOf(child); if (i > -1) go(i, smooth); };
    function buildDots() {
      if (!dotsWrap) return;
      var n = slides().length;
      dotsWrap.innerHTML = '';
      dots = [];
      dotsWrap.hidden = !active() || n < 2;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'tt-dot'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (k) { b.addEventListener('click', function () { go(k); }); })(i);
        dotsWrap.appendChild(b); dots.push(b);
      }
      paint(nearest());
    }
    function paint(i) { dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); }); }
    self.refresh = buildDots;

    // pointer drag
    var sx = 0, sy = 0, sl0 = 0, t0 = 0, startI = 0, dragging = false, down = false, moved = false, pid = null;
    el.querySelectorAll('img').forEach(function (im) { im.draggable = false; });
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('model-viewer, input, select, textarea')) return;
      // Fingers and pens use the browser's own swipe (native scroll + snap): it follows the finger
      // and works on every phone, tablet and in-app webview. JS drag is only for a mouse.
      if (e.pointerType !== 'mouse') return;
      if (!active() || !opts.mouse || e.button > 0) return;
      down = true; dragging = false; moved = false; pid = e.pointerId;
      sx = e.clientX; sy = e.clientY; sl0 = el.scrollLeft; t0 = Date.now(); startI = nearest();
    });
    el.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (!dragging) {
        if (Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) {
          dragging = true; el.classList.add('is-dragging');
          try { el.setPointerCapture(pid); } catch (err) {}
        } else if (Math.abs(dy) > 10) { down = false; return; }
      }
      if (dragging) { moved = true; el.scrollLeft = sl0 - dx; e.preventDefault(); }
    });
    function end(e) {
      if (!down) return; down = false;
      if (!dragging) return;
      dragging = false;
      clearTimeout(self._dt); self._dt = setTimeout(function () { el.classList.remove('is-dragging'); }, 450);
      var dx = (e.clientX || sx) - sx, dt = Math.max(1, Date.now() - t0), v = dx / dt;
      var target = startI;
      if (Math.abs(dx) > 40 || Math.abs(v) > 0.35) target = startI + (dx < 0 ? 1 : -1);
      else target = nearest();
      go(target);
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', function (e) { if (dragging) end(e); down = false; dragging = false; el.classList.remove('is-dragging'); });
    // swallow the click that ends a drag
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    // keep dots in sync with native scroll (trackpads, keyboard)
    var st; el.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { var i = nearest(); if (i !== self.index) { self.index = i; paint(i); fit(i); if (opts.onChange) opts.onChange(i, slides()[i]); } }, 80); }, { passive: true });
    if (opts.autoHeight) {
      el.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', function () { fit(self.index); }, { once: true }); });
      window.addEventListener('load', function () { fit(self.index); });
      requestAnimationFrame(function () { fit(self.index); });
    }
    el.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); self.next(); } if (e.key === 'ArrowLeft') { e.preventDefault(); self.prev(); } });
    if (mq) mq.addEventListener('change', function () { buildDots(); el.scrollLeft = 0; });
    window.addEventListener('resize', function () { clearTimeout(self._rt); self._rt = setTimeout(function () { if (dotsWrap && dots.length !== slides().length) buildDots(); fit(self.index); go(self.index, false); }, 150); });
    el.classList.add('tt-swipe');
    buildDots();
    return self;
  }

  function initMobileSliders(scope) {
    scope.querySelectorAll('.tt-mslider').forEach(function (el) {
      if (el._ttSlider) return;
      var dots = document.createElement('div');
      dots.className = 'tt-dots'; dots.setAttribute('role', 'group'); dots.setAttribute('aria-label', 'Slides');
      el.insertAdjacentElement('afterend', dots);
      var s = TTSlider(el, { media: '(max-width: 749px)', dots: dots });
      // product grid filters change which slides are visible
      el.addEventListener('tt:filtered', function () { el.scrollLeft = 0; s.refresh(); });
    });
  }


  /* ---------- size guide: pick a size in the product form ---------- */
  function initSize(sec) {
    var idx = parseInt(sec.getAttribute('data-option-index'), 10);
    var info = document.querySelector('product-info');
    var cards = [].slice.call(sec.querySelectorAll('.tt-sz'));
    function mark() {
      if (!info) return;
      var sel = null;
      var fs = info.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input');
      var f = fs[idx];
      if (f) { var c = f.querySelector('input:checked'); var sl = f.querySelector('select'); sel = c ? c.value : (sl ? sl.value : null); }
      cards.forEach(function (c) { c.classList.toggle('is-current', sel !== null && c.getAttribute('data-value') === sel); });
    }
    sec.querySelectorAll('[data-tt-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        var val = b.getAttribute('data-tt-pick');
        if (!info) return;
        var fs = info.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input');
        var f = fs[idx] || info;
        var radio = [].slice.call(f.querySelectorAll('input[type=radio]')).filter(function (r) { return r.value === val; })[0];
        var select = f.querySelector('select');
        if (radio) { if (!radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); } }
        else if (select) { select.value = val; select.dispatchEvent(new Event('change', { bubbles: true })); }
        mark();
        if (sec.getAttribute('data-scroll') === 'true') {
          var target = info.querySelector('.product-form__submit') || info;
          setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 150);
        }
      });
    });
    if (info) info.addEventListener('change', function () { setTimeout(mark, 50); });
    mark();
  }

  /* ---------- hotspots ---------- */
  function initHotspots(sec) {
    var items = sec.querySelectorAll('.tt-hs__item'), dots = sec.querySelectorAll('.tt-hs__dot');
    function set(n) {
      items.forEach(function (it) { var on = it.getAttribute('data-hs') === n; it.classList.toggle('is-active', on); var b = it.querySelector('.tt-hs__row'); if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      dots.forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-hs-btn') === n); });
    }
    sec.querySelectorAll('[data-hs-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.getAttribute('data-hs-btn'); set(n);
        if (b.classList.contains('tt-hs__dot') && window.matchMedia('(max-width: 749px)').matches) {
          var it = sec.querySelector('.tt-hs__item[data-hs="' + n + '"]'); if (it) it.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
      b.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) set(b.getAttribute('data-hs-btn')); });
    });
  }

  /* ---------- bought together ---------- */
  function initBundle(sec) {
    var rows = [].slice.call(sec.querySelectorAll('.tt-fbt__row'));
    var totalEl = sec.querySelector('[data-total]'), wasEl = sec.querySelector('[data-total-was]'), btn = sec.querySelector('[data-fbt-add]');
    var info = document.querySelector('product-info');
    var mainRow = sec.querySelector('[data-main]'), mainVariants = [];
    if (mainRow) { try { mainVariants = JSON.parse(mainRow.querySelector('[data-variants]').textContent); } catch (e) {} }
    function mainVariant() {
      var id = info && info.querySelector('form[action*="/cart/add"] input[name="id"]');
      var v = null;
      if (id) v = mainVariants.filter(function (x) { return String(x.id) === String(id.value); })[0];
      return v || mainVariants.filter(function (x) { return x.available; })[0] || mainVariants[0];
    }
    function rowData(r) {
      if (r.hasAttribute('data-main')) {
        var v = mainVariant(); if (!v) return null;
        return { id: v.id, p: v.price, c: v.compare_at_price || 0, on: true, title: v.title, avail: v.available };
      }
      var cb = r.querySelector('input[type=checkbox]'), h = r.querySelector('[data-vid]'), sel = r.querySelector('select');
      var id = h.value, p = +h.getAttribute('data-p'), c = +h.getAttribute('data-c');
      if (sel) { var o = sel.options[sel.selectedIndex]; id = o.value; p = +o.getAttribute('data-price'); c = +o.getAttribute('data-compare'); }
      return { id: id, p: p, c: c, on: cb.checked && !cb.disabled, avail: !cb.disabled };
    }
    function render() {
      var total = 0, was = 0, n = 0, ok = true;
      rows.forEach(function (r) {
        var d = rowData(r); if (!d) return;
        var pe = r.querySelector('[data-price]'); if (pe) pe.textContent = formatMoney(d.p);
        if (r.hasAttribute('data-main')) {
          var ve = r.querySelector('[data-main-variant]'); if (ve) ve.textContent = d.title && d.title !== 'Default Title' ? d.title : '';
          if (!d.avail) ok = false;
        }
        r.classList.toggle('is-off', !d.on);
        var pic = sec.querySelector('[data-pic="' + r.getAttribute('data-row') + '"]'); if (pic) pic.classList.toggle('is-off', !d.on);
        if (d.on) { total += d.p; was += Math.max(d.c, d.p); n++; }
      });
      totalEl.textContent = formatMoney(total);
      if (wasEl) { wasEl.hidden = !(was > total); wasEl.textContent = formatMoney(was); }
      btn.disabled = n === 0 || !ok;
      btn.textContent = n === 1 ? (sec.getAttribute('data-btn-one') || 'Add to bag') : (sec.getAttribute('data-btn') || 'Add [count] items to bag').replace('[count]', n);
    }
    sec.addEventListener('change', render);
    if (info) info.addEventListener('change', function () { setTimeout(render, 600); });
    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function' && PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(render, 30); });
    btn.addEventListener('click', function () {
      var items = [];
      rows.forEach(function (r) { var d = rowData(r); if (d && d.on) items.push({ id: Number(d.id), quantity: 1 }); });
      if (!items.length) return;
      var p = addItems(items, btn, items.length > 1 ? items.length + ' items' : null);
      if (p && p.then) p.then(function (ok) { if (!ok) return; btn.textContent = sec.getAttribute('data-added') || 'Added ✓'; setTimeout(render, 1800); });
    });
    render();
  }

  /* ---------- init ---------- */
  /* ---------- in-page links (#sizes, #reviews, #buy …) with sticky-header offset ---------- */
  function headerOffset() {
    var h = 0;
    var css = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
    var tt = document.querySelector('[data-tt-header]');
    if (tt && getComputedStyle(tt.parentElement || tt).position !== 'static') h = tt.offsetHeight;
    else if (css) h = css;
    return h + 12;
  }
  function findTarget(id) {
    var el = id ? document.getElementById(id) : null;
    if (!el && id === 'sizes') el = document.querySelector('[data-tt-section="size"]');
    if (!el && (id === 'sizes' || id === 'buy' || id === 'add' || id === 'MainContent')) {
      el = document.querySelector('product-info .product-form, product-info [id^="product-form"], product-info, [data-tt-section="featured"] form[data-tt-add], [data-tt-section="featured"]');
    }
    return el;
  }
  function scrollToId(id) {
    var el = findTarget(id); if (!el) return false;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    try { window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' }); } catch (e) { window.scrollTo(0, top); }
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"], [data-tt-scroll]');
    if (!a || !a.closest('.tt, .tt-pdp')) return;
    var id = a.getAttribute('data-tt-scroll') || (a.getAttribute('href') || '').slice(1);
    if (!id) return;
    try { id = decodeURIComponent(id); } catch (err) {}
    if (scrollToId(id)) e.preventDefault();
  });

  /* ---------- quick add buttons (size guide linked products) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-tt-quick-add]');
    if (!b) return;
    e.preventDefault();
    addItems([{ id: +b.getAttribute('data-tt-quick-add'), quantity: 1 }], b, b.getAttribute('data-tt-name') || '');
  });

  function init(scope) {
    scope = scope || document;
    if (cfg.animations === false) document.documentElement.classList.add('tt-no-anim');
    initReveal(scope);
    function once(fn) { return function (el) { if (el._ttInit) return; el._ttInit = true; fn(el); }; }
    scope.querySelectorAll('[data-tt-section="featured"]').forEach(once(initFeatured));
    scope.querySelectorAll('[data-tt-section="grid"]').forEach(once(initGrid));
    scope.querySelectorAll('[data-tt-section="quiz"]').forEach(once(initQuiz));
    scope.querySelectorAll('[data-tt-section="reviews"]').forEach(once(initVideos));
    scope.querySelectorAll('[data-tt-section="size"]').forEach(once(initSize));
    scope.querySelectorAll('[data-tt-section="hotspots"]').forEach(once(initHotspots));
    scope.querySelectorAll('[data-tt-section="bundle"]').forEach(once(initBundle));
    scope.querySelectorAll('.tt-sticky').forEach(initSticky);
    initMobileSliders(scope);
  }

  window.TTLanding = { init: init, slider: TTSlider, scrollTo: scrollToId, addToCart: addToCart, addItems: addItems, formatMoney: formatMoney, toast: showToast };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
